import React from 'react'
import { withStyles } from '@material-ui/core/styles'

// Semantic colours, separate from the brand accent (neutral redesign).
const TONES = {
    ok: { color: '#1e7a46', background: '#e2f3e9' },
    warn: { color: '#9a5b00', background: '#fdf0d9' },
    bad: { color: '#a83232', background: '#fbe4e4' },
    info: { color: '#0b6aa0', background: '#e3f2fb' },
    idle: { color: '#55606d', background: '#eceff3' }
}

/** Which tone a membership, standing or renewal status reads as. */
export const toneFor = (status) => {
    const s = String(status || '').toLowerCase()
    if (/^(active|trialing|good|renewed|enrolled)$/.test(s)) return 'ok'
    if (/past.?due|unpaid|delinquent/.test(s)) return 'warn'
    if (/cancel|expired|declined|failed/.test(s)) return 'bad'
    if (/removed/.test(s)) return 'idle'
    if (/sent|progress|signed|enrolling|scheduled/.test(s)) return 'info'
    return 'idle'
}

const styles = {
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 10px',
        borderRadius: 999,
        fontSize: '0.78rem',
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        textTransform: 'none',
        '&::before': {
            content: '""',
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'currentColor'
        }
    }
}

/**
 * A pill for a status: <StatusBadge label="Active" />, or with an explicit
 * tone. The label is shown as given (first letter capitalised).
 */
const StatusBadge = ({ classes, label, tone, ...rest }) => {
    if (!label) return null
    const text = String(label).charAt(0).toUpperCase() + String(label).slice(1)
    const palette = TONES[tone || toneFor(label)] || TONES.idle
    return <span className={classes.badge} style={palette} {...rest}>{text}</span>
}

export default withStyles(styles)(StatusBadge)
